import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { MessageInput } from "@/components/messages/MessageInput";
import { MessageList } from "@/components/messages/MessageList";
import { useToast } from "@/hooks/use-toast";
import { Message } from "@/types/messages";

const HostMessagesPage = () => {
  const { toast } = useToast();
  const [selectedMessageId, setSelectedMessageId] = useState("");
  const [messageContent, setMessageContent] = useState("");

  const { data: messages = [] } = useQuery({
    queryKey: ["host-messages"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { data, error } = await supabase
        .from("messages")
        .select(`
          *,
          sender:profiles!messages_user_id_fkey (
            full_name
          )
        `)
        .eq("recipient_id", user.id)
        .order("created_at", { ascending: false });

      if (error) throw error;
      return data as Message[];
    },
  });

  const handleSendMessage = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { error } = await supabase
        .from("messages")
        .insert({
          user_id: user.id,
          content: messageContent,
          subject: "Reply",
        });

      if (error) throw error;

      toast({
        title: "Success",
        description: "Message sent successfully",
      });
      
      setMessageContent(""); // Clear the input after sending
    } catch (error) {
      console.error("Error sending message:", error);
      toast({
        title: "Error",
        description: "Failed to send message",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Messages</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-1">
          <MessageList
            messages={messages}
            selectedMessageId={selectedMessageId}
            onSelectMessage={setSelectedMessageId}
          />
        </div>
        <div className="md:col-span-2">
          <MessageInput
            value={messageContent}
            onChange={setMessageContent}
            onSend={handleSendMessage}
            disabled={!messageContent.trim()}
          />
        </div>
      </div>
    </div>
  );
};

export default HostMessagesPage;